<template>
  <div >
    <div class="registered">
      <div class="registered_img"><img src="../../static/img/ren.png" alt=""></div>
      <ul>
        <li>
          <input type="number" placeholder="请输入手机号码"  oninput="if(value.length>11)value=value.slice(0,11)"  v-model.trim="phone" value="" />
        </li>
        <li class="validation clearfix">
          <input type="number" placeholder="短信验证码" class="lf"  v-model.trim="verify">
          <span v-if="sendMsgDisabled" class="rg">{{time+'秒后获取'}}</span>
          <span v-if="!sendMsgDisabled"  @click="send" class="rg">获取验证码</span>
        </li>
        <li>
          <input :type="password" placeholder="请设置密码(6-20位数字和字母组合)" ref ="password" v-model.trim="pas"  oninput="if(value.length>20)value=value.slice(0,20)">
          <div class="ShutDown rg">
            <em class="iconfont icon-yanjing"  @click="eye"  v-if="Shut"></em>
            <em class="iconfont icon-in_biyan" @click="eye" v-if="!Shut"></em>
          </div>
        </li>
        <li>
          <input type="text" placeholder="请输入邮箱" v-model.trim="email">
        </li>
        <!-- <li>
           <input type="text" placeholder="请输入邀请码" v-model.trim="invitedCode">
         </li>-->
        <li class="btn" @click="prosperity">下一步</li>
        <li class="agreement clearfix">
          点击"下一步"，即表示您同意遵守 <span @click="useragreement"> 【用户协议】</span>
        </li>
      </ul>
    </div>
    <!-- 提示框-->
    <prompt ref="errBox" :infor1="infor1"></prompt>
    <!--loading提示-->
    <loading ref="loading"></loading>
  </div>
</template>

<script>
  import prompt from '@/components/prompt'
  import {getUrlStr} from '../../static/js/Subparameter'
  import loading from '@/components/loading'
  export default {
    data(){
      return{
        Shut:false,//眼睛
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
        infor1:"",
        phone:"",
        verify:"",
        pas:"",
        email:"",
        invitedCode:"",
        password:"password",
        yanzhengma:"",
        sourceCode:"shqd1",
      }
    },
    components: {
      prompt,
      loading,
    },
    mounted () {
      /*  this.receive();*/
      this.getStorage();
    },
    methods:{
      /* //接受参数
       receive(){
       this.invitationcode = getUrlStr('invitationcode');
       },*/
      //眼睛
      eye:function(){
        this.Shut = !this.Shut;

        if(this.Shut == false ){
          this.password = 'password'
        }else{
          this.password = 'text'
        }
      },
      Tlphone:function(){

      },
      //下一步
      prosperity:function(){
        const email = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        const myreg=/^((1[0-9]{1})+\d{9})$/
        const reg = /^(?![^a-zA-Z]+$)(?!\D+$)/;
        let register = {
          telephone:this.phone,
          code:this.verify,
          password:this.pas,
          email:this.email,
          invitedCode:this.invitedCode,
          sourceCode:this.sourceCode,
        }
        if(register.telephone == "" || !myreg.test(register.telephone)){
          this.$refs.errBox.errorShow();
          this.infor1='请输入正确的手机号！'
          return false;
        }else if(register.code == "" || register.code !== this.yanzhengma){
          this.$refs.errBox.errorShow();
          this.infor1='请输入正确验证码！'
          return false;
        }else if(register.password == "" || !reg.test(register.password) ||  register.password.length< 6 ||register.password.length >20 ){
          this.$refs.errBox.errorShow();
          this.infor1='6-20位数字和字母组合!'
          return false;
        }else if(register.email == "" || !email.test(register.email)){
          this.$refs.errBox.errorShow();
          this.infor1="请输入正确的邮箱!"
          return false;
        }
        this.$router.push({
          name:"autonymShqd1",
          query:{
            telephone:this.phone,
            code:this.verify,
            password:this.pas,
            email:this.email,
            invitedCode:this.invitedCode,
            sourceCode:this.sourceCode,
          }
        })
      },
      //获取短信验证码
      send:function() {
        this.$refs.loading.loadShow();
        const backdata={
          tel:this.phone,
          type:"0",
        }
        const myreg=/^((1[0-9]{1})+\d{9})$/
        if(this.phone == undefined || this.phone == ""||!myreg.test(this.phone)){
          this.sendMsgDisabled = false;
          this.$refs.errBox.errorShow();
          this.$refs.loading.loadclose();
          this.infor1 = '请输入正确手机号！'
          return false;
        }
        this.$http.get('/common/sendSmsCode',{params:backdata}).then(res => {
          var message = res.data.message;
        if(res.data.code == "200"){
          this.$refs.loading.loadclose();
          this.yanzhengma = res.data.data.verifyCode
          this.htnpop();
        }
        if(res.data.code == "500"){
          this.$refs.loading.loadclose();
          this.$refs.errBox.errorShow();
          this.infor1 = message;
          this.sendMsgDisabled = false;
          return false;
        }
      })
      },
      /* 校验提示*/
      htnpop:function(){
        window.clearInterval(interval);
        let me = this;
        me.sendMsgDisabled = true;
        let interval = window.setInterval(function () {
          if ((me.time--) <= 0) {
            me.time = 60;
            me.sendMsgDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);

      },
      /*用户协议*/
      useragreement:function(){
        sessionStorage.setItem('phone', this.phone);
        sessionStorage.setItem('verify', this.verify);
        sessionStorage.setItem('pas', this.pas);
        sessionStorage.setItem('email', this.email);
        sessionStorage.setItem('invitedCode', this.invitedCode);
        sessionStorage.setItem('sourceCode', this.sourceCode);
        this.$router.push({
          name:"useragreement"
        })
      },
      //获取数据
      getStorage:function(){
        var phone = sessionStorage.getItem('phone')
        var  verify = sessionStorage.getItem('verify')
        var pas = sessionStorage.getItem('pas')
        var email =sessionStorage.getItem('email')
        var invitedCode =sessionStorage.getItem('invitedCode')
        var sourceCode =sessionStorage.getItem('sourceCode')

        if(this.phone == ""||this.phone==null){
          if(phone == null){
            this.phone = ""
          }else{
            this.phone = phone;
          }
        }
        if(this.verify == ""||this.verify==null){
          if(verify == null){
            this.verify = ""
          }else{
            this.verify = verify;
          }

        }
        if(this.pas == ""||this.pas==null){
          if(pas == null){
            this.pas = "";
          }else{
            this.pas = pas;
          }

        }
        if(this.email == ""||this.email==null){
          if(email == null){
            this.email = "";
          }else{
            this.email = email;
          }
        }
        if(this.invitedCode == ""||this.invitedCode==null){
          if(invitedCode == null){
            this.invitedCode = "";
          }else{
            this.invitedCode = invitedCode;
          }

        }
        if(this.sourceCode == ""||this.sourceCode==sourceCode){
          if(sourceCode == null){
            this.sourceCode = "";
          }else{
            this.sourceCode = sourceCode;
          }
        }
      }

    }
  }
</script>

<style scoped lang="less">
  .registered{
    position:relative;
  .registered_img img{
    width:100%;
  }
  .agreement{
    border-bottom:none;
    text-align:center;
  span{
    color:#6699FF;
  }
  }
  ul{
    background:#ffffff;
    width:690/75rem;
    position:absolute;
    bottom:70/75rem;
    left:50%;
    transform:translate(-50%);
    -ms-transform: translate( -50%);
    -moz-transform: translate( -50%);
    -webkit-transform: translate( -50%);
    -o-transform: translate( -50%);
    margin:auto;
    border-radius:4/75rem;
    padding-top:20/75rem;
  }
  li{
    font-size:28/74rem;
    color:#cccccc;
    line-height:110/75rem;
    position: relative;
    margin:0 30/75rem;
    border-bottom:1px solid #E2E5E7;
  &.validation{
  input{
    width:400/75rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  span{
    width:200/75rem;
    height:80/75rem;
    line-height:80/75rem;
    margin:auto;
    color:#E6464A;
    font-size:32/75rem;
    border-radius: 6px;
    text-align:right;
    margin-top:15/75rem;
  }
  }
  input{
    width:600/75rem;
    height:110/75rem;
    /* line-height:110/75rem;*/
    border:none 0;
    padding-left:5/75rem;
    font-size:28/75rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  input::-webkit-input-placeholder{
    font-size:28/75rem;
    color:#cccccc;
  }
  }
  .ShutDown{
    position:absolute;
    top:0;
    right:0;
    font-size:40/75rem;
  }
  /*保存*/
  .btn{
    width:629/75rem;
    margin:auto;
    background:#E6464A;
    color:#fff;
    font-size:32/75rem;
    border-radius: 6px;
    text-align:center;
    box-shadow:4px 0px 16px rgba(153,153,153,0.63);
    margin-top:80/75rem;
  }
  }

</style>



// WEBPACK FOOTER //
// src/pages/registerShqd1.vue